import { MFASMSSetup } from "./MFASMSSetup"
import { MFAEmailSetup } from "./MFAEmailSetup"
import {
	MfaMethod,
	useSecuritySectionStore
} from "../stores/securitySectionStore"
import { MFA_METHODS } from "@utils/constants.util"

export const MFASetupFlow = () => {
	const { currentStep } = useSecuritySectionStore()

	const method = currentStep?.data?.method as MfaMethod

	if (method === MFA_METHODS.SMS) return <MFASMSSetup />
	if (method === MFA_METHODS.EMAIL) return <MFAEmailSetup />

	return null
}
